import React from 'react';
import PropTypes from 'prop-types';
import ExternalLink from '../../../../common/components/ExternalLink';
import config from '../../../../../../core/config/configureSettings';

const ItemOverviewDetails = (props) => {
  let datas = {};
  const { atatSystem } = config.applications;
  const host = atatSystem;
  let pathItemId;
  let pathDespatchId;
  let pathReceptacleId;
  /* eslint-disable react/destructuring-assignment */
  if (props.data.length > 0) {
    /* eslint-disable react/destructuring-assignment, prefer-destructuring */
    datas = props.data[0];
    pathItemId = `/en/item/${datas.itemId}`;
    pathDespatchId = `/en/despatch/${datas.despatchId}`;
    pathReceptacleId = `/en/receptacle/${datas.receptacleId}`;
  }
  return (
    <div className="main-div">
      <div className="first-row">
        <div className="first-table">
          <table>
            <tr>
              <td className="title-td-padding">
                ITEM ID
              </td>
              <td className="bordered-td">
                <ExternalLink host={host} label={datas.itemId} path={pathItemId} />
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                DESPATCH ID
              </td>
              <td className="bordered-td">
                <ExternalLink host={host} label={datas.despatchId} path={pathDespatchId} />
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                RECEPTACLE ID
              </td>
              <td className="bordered-td">
                <ExternalLink host={host} label={datas.receptacleId} path={pathReceptacleId} />
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                MAIL SUBCLASS
              </td>
              <td className="bordered-td">
                {datas.mailSubclass}
              </td>
            </tr>
          </table>
        </div>
        <div className="second-table">
          <table>
            <tr>
              <td />
              <td className="title-td">
                Operator
              </td>
              <td className="title-td">
                IMPC
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                FROM
              </td>
              <td className="bordered-td">
                {datas.operatorFrom}
              </td>
              <td className="bordered-td">
                {datas.impcFrom}
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                TO
              </td>
              <td className="bordered-td">
                {datas.operatorTo}
              </td>
              <td className="bordered-td">
                {datas.impcTo}
              </td>
            </tr>
          </table>
        </div>
        <div className="third-table">
          <table>
            <tr>
              <td className="title-td">
                CURRENT STATUS
              </td>
            </tr>
            <tr>
              <td className="bordered-td">
                {datas.currentStatus}
              </td>
            </tr>
            <tr>
              <td className="bordered-td">
                {datas.currentStatusDataTime}
              </td>
            </tr>
          </table>
        </div>
        <div className="fourth-table">
          <table>
            <tr>
              <td className="title-td">
                DUTIABLE
              </td>
            </tr>
            <tr>
              <td className="bordered-td">
                {datas.dutiable !== null ? datas.dutiable : <span>&nbsp;</span>}
              </td>
            </tr>
          </table>
        </div>
        <div className="fifth-table">
          <table>
            <tr>
              <td className="title-td">
                OUT TO TRANSIT
              </td>
              <td className="title-td">
                RETURN
              </td>
              <td className="title-td">
                TRANSIT THROUGH
              </td>
            </tr>
            <tr>
              <td className="bordered-td">
                {datas.outToTransit}
              </td>
              <td className="bordered-td">
                {datas.returnn}
              </td>
              <td className="bordered-td">
                {datas.transitThrough}
              </td>
            </tr>
          </table>
        </div>
        <div className="sixth-table">
          <fieldset>
            <legend>ITMATT</legend>
            <table>
              <tr>
                <td className="title-td-padding">
                  IN ITMATT
                </td>
                <td className="bordered-td">
                  {datas.inItmatt}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  PARTY NAME
                </td>
                <td className="bordered-td">
                  {datas.partyName}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  PARTY ID
                </td>
                <td className="bordered-td">
                  {datas.partyIdentifier}
                </td>
              </tr>
            </table>
          </fieldset>
        </div>
      </div>
      <div className="second-row">
        <div className="seventh-table">
          <fieldset>
            <legend>Entry Dates</legend>
            <table>
              <tr>
                <td className="title-td-padding">
                  ENTRY DATE
                </td>
                <td className="bordered-td">
                  {datas.entryDate}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  ENTRY WEEK
                </td>
                <td className="bordered-td">
                  {datas.entryWeek}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  ENTRY MONTH
                </td>
                <td className="bordered-td">
                  {datas.entryMonth}
                </td>
              </tr>
            </table>
          </fieldset>
        </div>
        <div className="eighth-table">
          <fieldset>
            <legend>
              EMA
            </legend>
            <table>
              <tr>
                <td />
                <td className="title-td">
                  Country
                </td>
                <td className="title-td">
                  OE
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  FROM
                </td>
                <td className="bordered-td-half">
                  {datas.countryFrom}
                </td>
                <td className="bordered-td-half">
                  {datas.outwardOE}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  TO
                </td>
                <td className="bordered-td-half">
                  {datas.countryTo}
                </td>
                <td className="bordered-td-half">
                  {datas.inwardOE}
                </td>
              </tr>
            </table>

            <table className="new-table-left">
              <tr>
                <td className="title-td-padding-first-column">
                  DELIVERY OFFICE
                </td>
                <td className="bordered-td">
                  {datas.deliveryOffice}
                </td>
              </tr>
            </table>

            <table className="new-table-left">
              <tr>
                <td className="title-td-padding">
                  WEIGHT EMA EMC
                </td>
                <td className="bordered-td">
                  {datas.weightEmaEmc}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  WEIGHT ITMATT
                </td>
                <td className="bordered-td">
                  {datas.weightItmatt}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  EMA EMC VOLUME
                </td>
                <td className="bordered-td">
                  {datas.emaEmcVolume}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  EMD ITEM VOLUME
                </td>
                <td className="bordered-td">
                  {datas.emdItemVolume}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  FORMAT OF CONTENTS
                </td>
                <td className="bordered-td">
                  {datas.formatOfContents}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  ADDRESSE POSTCODE
                </td>
                <td className="bordered-td">
                  {datas.addresseePostCode}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  PLACE OF DESTINATION
                </td>
                <td className="bordered-td">
                  {datas.placeOfDestination}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  ORIG OFFICE
                </td>
                <td className="bordered-td">
                  {datas.originOffice}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  SENDER POSTCODE
                </td>
                <td className="bordered-td">
                  {datas.senderPostCode}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  ORIGIN LOCATION
                </td>
                <td className="bordered-td">
                  {datas.originLocation}
                </td>
              </tr>
            </table>
          </fieldset>
        </div>
        <div className="ninth-table">
          <fieldset>
            <legend>
              Event Times
            </legend>
            <div className="left-table">
              <table>
                <tr>
                  <td className="title-td-padding">
                    EMA
                  </td>
                  <td className="bordered-td">
                    {datas.ema}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EMB
                  </td>
                  <td className="bordered-td">
                    {datas.emb}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EXA
                  </td>
                  <td className="bordered-td">
                    {datas.exa}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EXB
                  </td>
                  <td className="bordered-td">
                    {datas.exb}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EXC
                  </td>
                  <td className="bordered-td">
                    {datas.exc}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EXD
                  </td>
                  <td className="bordered-td">
                    {datas.exd}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EXX
                  </td>
                  <td className="bordered-td">
                    {datas.exx}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EMC
                  </td>
                  <td className="bordered-td">
                    {datas.emc}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EMJ
                  </td>
                  <td className="bordered-td">
                    {datas.emj}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EMK
                  </td>
                  <td className="bordered-td">
                    {datas.emk}
                  </td>
                </tr>
              </table>
            </div>

            <div className="right-table">
              <table>
                <tr>
                  <td className="title-td-padding">
                    EMD
                  </td>
                  <td className="bordered-td">
                    {datas.emd}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EDA
                  </td>
                  <td className="bordered-td">
                    {datas.eda}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EDB
                  </td>
                  <td className="bordered-td">
                    {datas.edb}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EME
                  </td>
                  <td className="bordered-td">
                    {datas.eme}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EDC
                  </td>
                  <td className="bordered-td">
                    {datas.edc}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EMF
                  </td>
                  <td className="bordered-td">
                    {datas.emf}
                  </td>
                </tr>
              </table>

              <table className="new-table">
                <tr>
                  <td className="title-td-padding">
                    EDE
                  </td>
                  <td className="bordered-td">
                    {datas.ede}
                  </td>
                </tr>
              </table>

              <table className="new-table">
                <tr>
                  <td className="title-td-padding">
                    EDF
                  </td>
                  <td className="bordered-td">
                    {datas.edf}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EDG
                  </td>
                  <td className="bordered-td">
                    {datas.edg}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EDH
                  </td>
                  <td className="bordered-td">
                    {datas.edh}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EDX
                  </td>
                  <td className="bordered-td">
                    {datas.edx}
                  </td>
                </tr>
              </table>

              <table className="new-table">
                <tr>
                  <td className="title-td-padding">
                    EMH
                  </td>
                  <td className="bordered-td">
                    {datas.emh}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EMI
                  </td>
                  <td className="bordered-td">
                    {datas.emi}
                  </td>
                </tr>
              </table>
            </div>
          </fieldset>
        </div>
        <div className="multiple-rows">
          <div className="tenth-table">
            <fieldset>
              <legend>
                EMF
              </legend>
              <table>
                <tr>
                  <td className="title-td-padding">
                    Type
                  </td>
                  <td className="bordered-td">
                    {datas.emfType}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    ID
                  </td>
                  <td className="bordered-td">
                    {datas.emfId}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    Postcode
                  </td>
                  <td className="bordered-td">
                    {datas.emfPostCode}
                  </td>
                </tr>
              </table>
            </fieldset>
          </div>
          <div className="eleventh-table">
            <fieldset>
              <legend>
                EMH
              </legend>
              <table>
                <tr>
                  <td className="title-td-padding">
                    Code
                  </td>
                  <td className="bordered-td-half">
                    {datas.emhCode}
                  </td>
                </tr>
              </table>

              <table className="new-table">
                <tr>
                  <td className="title-td-padding">
                    Reason
                  </td>
                  <td className="bordered-td">
                    {datas.emhReason}
                  </td>
                </tr>
              </table>
            </fieldset>
          </div>
          <div className="twelfth-table">
            <fieldset>
              <legend>
                EDD
              </legend>
              <table>
                <tr>
                  <td />
                  <td className="title-td">
                    Event Time
                  </td>
                  <td className="title-td">
                    Sort Centre
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EDD 1
                  </td>
                  <td className="bordered-td">
                    {datas.edd1EventTime}
                  </td>
                  <td className="bordered-td">
                    {datas.edd1SortCentre}
                  </td>
                </tr>
                <tr>
                  <td className="title-td-padding">
                    EDD N
                  </td>
                  <td className="bordered-td">
                    {datas.eddNEventTime}
                  </td>
                  <td className="bordered-td">
                    {datas.eddNSortCentre}
                  </td>
                </tr>
              </table>
            </fieldset>
          </div>
          <div className="thirteenth-table">
            <fieldset>
              <legend>
                EMG
              </legend>
              <table>
                <tr>
                  <td className="title-td-padding">
                    EMG
                  </td>
                  <td className="bordered-td">
                    {datas.emgEventTime}
                  </td>
                  <td className="bordered-td">
                    {datas.emgSortCentre}
                  </td>
                </tr>
              </table>
            </fieldset>
          </div>
        </div>
      </div>
      <div className="third-row">
        <div className="fourteenth-table">
          <table>
            <tr>
              <td />
              <td className="title-td">
                Duration
              </td>
              <td className="title-td">
                Start Scan
              </td>
              <td className="title-td">
                Event
              </td>
              <td className="title-td">
                Stop Scan
              </td>
              <td className="title-td">
                Stop Event
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                E2E OPS
              </td>
              <td className="bordered-td">
                {datas.e2eOpsDuration}
              </td>
              <td className="bordered-td">
                {datas.e2eOpsStartScan}
              </td>
              <td className="bordered-td">
                {datas.e2eOpsEvent}
              </td>
              <td className="bordered-td">
                {datas.e2eOpsStopScan}
              </td>
              <td className="bordered-td">
                {datas.e2eOpsStopEvent}
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                E2E BUSINESS
              </td>
              <td className="bordered-td">
                {datas.e2eBusinessDuration}
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                E2E BUSINESS EXCLUDING CUSTOMS
              </td>
              <td className="bordered-td">
                {datas.e2eBusinessExclCustomsDuration}
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                DAYS IN CUSTOMS
              </td>
              <td className="bordered-td">
                {datas.daysInCustomsDuration}
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                LEG 1
              </td>
              <td className="bordered-td">
                {datas.leg1Duration}
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                LEG 2
              </td>
              <td className="bordered-td">
                {datas.leg2Duration}
              </td>
              <td className="bordered-td">
                {datas.leg2StartScan}
              </td>
              <td className="bordered-td">
                {datas.leg2Event}
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                LEG 3
              </td>
              <td className="bordered-td">
                {datas.leg3Duration}
              </td>
              <td className="bordered-td">
                {datas.leg3StartScan}
              </td>
              <td className="bordered-td">
                {datas.leg3Event}
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                LEG 3 INTERNATIONAL
              </td>
              <td className="bordered-td">
                {datas.leg3InternationalDuration}
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                LEG 3 DOMESTIC
              </td>
              <td className="bordered-td">
                {datas.leg3DomesticDuration}
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
            </tr>
          </table>
        </div>
        <div className="fifteenth-table">
          <table>
            <tr>
              <td />
              <td className="title-td">
                Event Time
              </td>
              <td className="title-td">
                Flight
              </td>
              <td className="title-td">
                Location
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                DESPATCH CLOSED
              </td>
              <td className="bordered-td">
                {datas.despatchClosedEventTime}
              </td>
              <td className="bordered-td">
                {datas.despatchClosedFlight}
              </td>
              <td className="bordered-td">
                {datas.despatchClosedLocation}
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                PRECON
              </td>
              <td className="bordered-td">
                {datas.preconEventTime}
              </td>
              <td className="bordered-td">
                {datas.preconFlight}
              </td>
              <td className="bordered-td">
                {datas.preconLocation}
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                CARDIT
              </td>
              <td className="bordered-td">
                {datas.carditEventTime}
              </td>
              <td className="bordered-td">
                {datas.carditFlight}
              </td>
              <td className="bordered-td">
                {datas.carditLocation}
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                RD 74
              </td>
              <td className="bordered-td">
                {datas.resdit74EventTime}
              </td>
              <td className="bordered-td">
                {datas.resdit74Flight}
              </td>
              <td className="bordered-td">
                {datas.resdit74Location}
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                RD 21
              </td>
              <td className="bordered-td">
                {datas.resdit21EventTime}
              </td>
              <td className="bordered-td">
                {datas.resdit21Flight}
              </td>
              <td className="bordered-td">
                {datas.resdit21Location}
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                RD 23
              </td>
              <td className="bordered-td">
                {datas.resdit23EventTime}
              </td>
              <td className="bordered-td">
                {datas.resdit23Flight}
              </td>
              <td className="bordered-td">
                {datas.resdit23Location}
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                POD
              </td>
              <td className="bordered-td">
                {datas.podEventTime}
              </td>
              <td className="bordered-td">
                {datas.podFlight}
              </td>
              <td className="bordered-td">
                {datas.podLocation}
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                RESCON
              </td>
              <td className="bordered-td">
                {datas.resconEventTime}
              </td>
              <td className="bordered-td">
                {datas.resconFlight}
              </td>
              <td className="bordered-td">
                {datas.resconLocation}
              </td>
            </tr>
            <tr>
              <td className="title-td-padding">
                BAG SCAN
              </td>
              <td className="bordered-td">
                {datas.bagScanEventTime}
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
              <td className="bordered-td-colored">
                &nbsp;
              </td>
            </tr>
          </table>
        </div>
        <div className="sixteenth-table">
          <fieldset>
            <legend>
              On Network
            </legend>
            <table>
              <tr>
                <td className="title-td-padding">
                  EDH
                </td>
                <td className="bordered-td">
                  {datas.onNetworkEdh}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  EMH
                </td>
                <td className="bordered-td">
                  {datas.onNetworkEmh}
                </td>
              </tr>
              <tr>
                <td className="title-td-padding">
                  EMI
                </td>
                <td className="bordered-td">
                  {datas.onNetworkEmi}
                </td>
              </tr>
            </table>
          </fieldset>
        </div>
      </div>
    </div>
  );
};

ItemOverviewDetails.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

export default ItemOverviewDetails;
